<h3-image-content-initializer
  [project]="taskWorkspaceStore.state().project"
  [output]="outputInfoStore.state().output"
  [readOnly]="taskWorkspaceStore('readOnly').$ | async"
  [isClientFeedbacksEditable]="isClientFeedbacksEditable"
  [isShapeFeedbackEditable]="isShapeFeedbackEditable"
  [currentUser]="taskWorkspaceStore.state().currentUser"
  [stepId]="taskWorkspaceStore.state().stepId"
  (initializationComplete)="onContentInitialized($event)"
></h3-image-content-initializer>
@if (contentInjector) {
  <h3-image-annotation-layout
    [state]="store.$ | async"
  ></h3-image-annotation-layout>
}

<ng-container
  *ngIf="showAddRandomShapes && (store.$ | async)?.status === 'ready'"
>
  <hr />
  <h3-add-random-shapes></h3-add-random-shapes>
</ng-container>
